<template>
  <div>

    <div class="flexc-cen-x fixed">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
       <el-breadcrumb-item>{{name}}</el-breadcrumb-item>
      </el-breadcrumb>
      <el-select  v-if="DianList.length>1" style="margin-left:20px;width:140px" size="mini" v-model="SelectStoresID" @change="changedian()" placeholder="门店">
          <el-option
              v-for="item in DianList"
              :key="item.ID"
              :label="item.StoresName"
              :value="item.ID"
            >
          </el-option>
      </el-select>
    </div>
    <div class="csss">
      <el-form :inline="true" :model="formInline"  style="display:flex;flex-wrap:wrap;padding-top:30px">
        <el-form-item label="搜索：">
          <el-input size="mini" placeholder="请输入姓名/手机号"  style="width:150px" v-model="selectMembersName"  auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item :label="WZCDName+'：'"  prop="Site" v-if="IsCD == 1">
            <el-select v-model="Site" clearable placeholder="请选择" size="mini">
                  <el-option
                    v-for="item in siteList"
                    :key="item.ID"
                    :label="item.SiteName"
                    :value="item.ID">
                  </el-option>
                </el-select>
        </el-form-item>
        <el-form-item :label="WZXMName +'：'" prop="objID">
            <el-select clearable v-model="objID" placeholder="请选择" size="mini">
                <el-option
                    v-for="item in projectList"
                    :key="item.ID"
                    :label="item.ProjectName"
                    :value="item.ID">
                </el-option>
            </el-select>
        </el-form-item>
          <el-form-item label="预约状态：" prop="selectstate">
        <el-select v-model="selectstate"   size="mini">
            <el-option label="全部" value="0"></el-option>
            <el-option label="已预约" value="1"></el-option>
            <el-option :label="'已'+typeName" value="2"></el-option>
           <el-option label="已取消" value="3"></el-option>
        </el-select> 
       </el-form-item>
        <el-form-item label="时间:">
            <el-date-picker
              v-model="tdate"
              type="date"
              placeholder="选择日期"
              size="mini"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              style="width:170px"
              >
            </el-date-picker>
               至
            <el-date-picker
              v-model="mdate"
              type="date"
              placeholder="选择日期"
              size="mini"
              style="width:170px"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              >
            </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableData" highlight-current-row v-loading="loading" size="mini"   element-loading-text="拼命加载中" style="width:100%;margin-top:10px">
          <el-table-column  prop="Phone" label="预约时间"  width="170" >
            <template slot-scope="scope"> 
              <div class="flex-xy">
                {{scope.row.SKtime}} {{scope.row.startTimeNew}}
              </div>
            </template>
          </el-table-column>
          <el-table-column  prop="TcStaffTypeID" :label="WZXMName +'名称'"  width="170">
            <template slot-scope="scope">
                <div class="flexc-cen-x">
                <img :src="scope.row.ProjectHeadUrl" style="width:25px;height:25px;border-radius:100%" alt="">
                <div style="margin-left:5px;font-size:13px">{{scope.row.ProjectName}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column  prop="Name" label="服务人员"  width="170">
            <template slot-scope="scope">
                <div class="flexc-cen-x">
                <img :src="scope.row.terHeadUrl" v-if="scope.row.terHeadUrl!='' " style="width:25px;height:25px;border-radius:100%" alt="">
                <img v-if="scope.row.terHeadUrl =='' " src="../../assets/img/head.png" style="width:25px;height:25px;border-radius:100%" alt="">
                <div style="margin-left:5px;font-size:13px">{{scope.row.terName}}</div>    
              </div>
            </template>
          </el-table-column>
          <el-table-column  prop="SiteName" :label="WZCDName"  v-if="IsCD == 1">
          </el-table-column>
          <el-table-column  prop="Name" label="顾客信息"  width="140">
            <template slot-scope="scope">
                <div class="flexc-cen-x">
                <img :src="scope.row.HeadUrl" v-if="scope.row.HeadUrl !='' " style="width:25px;height:25px;border-radius:100%" alt="">
                <img v-if="scope.row.HeadUrl =='' " src="../../assets/img/head.png" style="width:25px;height:25px;border-radius:100%" alt="">
                <div v-if="scope.row.Name !=''" style="margin-left:5px;font-size:13px">{{scope.row.Name}}</div>
                <div v-else style="margin-left:5px;font-size:13px">{{scope.row.wxName}}</div>  
              </div>
            </template>
          </el-table-column>
          <el-table-column  prop="Phone" label="联系电话"  align="center" width="100">
          </el-table-column>
          <el-table-column  prop="yyLoginName" label="预约操作人"  align="center" width="100">
          </el-table-column>
           <el-table-column  prop="qdLoginName" label="签到操作人"  align="center" width="100">
          </el-table-column>
          <el-table-column prop="PreAboutCount" label="预约人数" align="center" >
             <template slot-scope="scope"> 
               <div class="flex-xy" @click="toNumber(scope.row)" v-if="scope.row.state == 1">
                  <div class="flexc-cen-x">
                    <div style="width:30px;color:#409EFF">{{scope.row.PreAboutCount}}</div>
                    <el-button type="text" icon="el-icon-edit"></el-button>
                  </div>
              </div>
             <div class="flex-xy"  v-if="scope.row.state != 1">
                <div style="width:30px;margin-left:-17px">{{scope.row.PreAboutCount}}</div>
                 
              </div>
            </template>
          </el-table-column>
          <el-table-column  prop="state" label="状态" align="center" width="80">
            <template slot-scope="scope">
                    <span class="Info" v-if="scope.row.state == 0">
                      学员取消
                    </span>
                    <span class="coBlue" v-if="scope.row.state == 1">
                    已预约
                    </span>
                    <span class="Success" v-if="scope.row.state == 2">
                      已{{name}}
                    </span>
                    <span class="Danger" v-if="scope.row.state == 3">
                    未到
                    </span>
                    <span class="Info" v-if="scope.row.state == 4">
                      机构取消
                    </span>
                    <span class="Warning" v-if="scope.row.state == 5">
                    请假
                    </span>
            </template>
          </el-table-column>
        <el-table-column align="center" label="操作" width="380" >
          <template slot-scope="scope">
            <el-button  size="mini" type="primary" v-if="q1 == true" @click="handleEdit(scope.row)">详情</el-button>
            <el-button size="mini" type="primary" v-if="scope.row.state == 2 && q6 == true"   @click="dian(scope.row)" >点评</el-button>
            <el-button size="mini" type="primary" v-if="scope.row.state != 2 && q6 == true" disabled @click="dian(scope.row)" >点评</el-button>
            <el-button size="mini" type="success" v-if="scope.row.state == 1 && q2 == true" @click="hexiao(scope.row)" >{{typeName}}</el-button>
            <el-button size="mini" type="success"  v-if="(scope.row.state == 2||scope.row.state == 3 || scope.row.state == 5) && q5 == true" @click="chexiao(scope.row)" >撤销</el-button>
            <el-button size="mini" type="warning" v-if="scope.row.state == 1 && q3 == true" @click="toOther(scope.row)">其他</el-button>
            <el-button size="mini" type="warning" disabled v-if="scope.row.state != 1 && q3 == true" @click.native.prevent="todel(scope.row)" >其他</el-button>
            <el-button size="mini" type="info" disabled v-if="scope.row.state != 1 && q4 == true" @click.native.prevent="todel(scope.row)" >取消预约</el-button>
            <el-button size="mini" type="info" v-if="scope.row.state == 1 && q4 == true" @click.native.prevent="todel(scope.row)" >取消预约</el-button>
          </template>
        </el-table-column>
    </el-table>
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!--列表-->

    <!-- 分页组件 -->
    
    <!-- 编辑界面 -->
    <el-drawer :wrapperClosable= false  title="详情" :visible.sync="editFormVisible" :direction="direction" size="30%">
      <div class="bottomBORD">
        <div style="margin-left:2%;font-size:15px">服务信息</div>
          <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:30px">
              <div style="color:#7e7e7e;width:80px">状态：</div>
              <div> <span class="Info" v-if="mainList.state == 0">
                    学员取消
                  </span>
                  <span class="coBlue" v-if="mainList.state == 1">
                   已预约
                  </span>
                  <span class="Success" v-if="mainList.state == 2">
                    已{{typeName}}
                  </span>
                  <span class="Danger" v-if="mainList.state == 3">
                   未到
                  </span>
                  <span class="Info" v-if="mainList.state == 4">
                    机构取消
                  </span>
                  <span class="Warning" v-if="mainList.state == 5">
                   请假
                  </span>
              </div>
          </div>
            <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px">{{WZXMName}}名称：</div>
                  <div class="flexc-cen-x">
                    <img :src="mainList.ProjectHeadUrl" style="width:25px;height:25px;border-radius:100%" alt="">
                    <div style="margin-left:5px;font-size:13px">{{mainList.ProjectName}}</div>
                  </div>
            </div>
            <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px">服务人员：</div>
                    <div class="flexc-cen-x">
                      <img :src="mainList.terHeadUrl" v-if="mainList.terHeadUrl!='' " style="width:25px;height:25px;border-radius:100%" alt="">
                      <img v-if="mainList.terHeadUrl =='' " src="../../assets/img/head.png" style="width:25px;height:25px;border-radius:100%" alt="">
                    <div style="margin-left:5px;font-size:13px">{{mainList.terName}}</div>
                  </div>
            </div>
            <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:10px" v-if="IsCD == 1 && mainList.SiteName !=''">
                  <div style="color:#7e7e7e;width:80px" >{{WZCDName}}：</div>
                  <div class="flexc-cen-x">
                    <div style="margin-left:5px;font-size:13px">{{mainList.SiteName}}</div>
                  </div>           
            </div>
            <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px">{{WZXMName}}时间：</div>
                  <div class="flexc-cen-x">
                    <div style="margin-left:5px;font-size:13px">{{mainList.SKtime}} {{mainList.startTimeNew}}</div>
                  </div>
            </div>
            <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px">{{WZXMName}}时长：</div>
                  <div class="flexc-cen-x">
                    <div style="margin-left:5px;font-size:13px">{{mainList.Timelength}} 分钟</div>
                  </div>
            </div>
      </div>
      <div class="bottomBORD" style="margin-top:30px">
        <div style="margin-left:2%;font-size:15px">顾客信息</div>

            <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:30px">
                  <div style="color:#7e7e7e;width:80px">姓名：</div>
                    <div class="flexc-cen-x">
                      <img :src="row.HeadUrl" v-if="row.HeadUrl!='' " style="width:25px;height:25px;border-radius:100%" alt="">
                      <img v-if="row.HeadUrl =='' " src="../../assets/img/head.png" style="width:25px;height:25px;border-radius:100%" alt="">
                    <div v-if="row.Name !=''" style="margin-left:5px;font-size:13px">{{row.Name}}</div>
                    <div v-if="row.Name ==''" style="margin-left:5px;font-size:13px">{{row.wxName}}</div>
                  </div>
            </div>
            
            <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px">预约人数：</div>
                  <div class="flexc-cen-x">
                    <div style="margin-left:5px;font-size:13px">{{mainList.PreAboutCount}}</div>
                  </div>
            </div>
            <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px">预约时间：</div>
                  <div class="flexc-cen-x">
                    <div style="margin-left:5px;font-size:13px">{{mainList.addTime}}</div>
                  </div>
            </div>
           
            <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px">预约方式：</div>
                  <div class="flexc-cen-x" v-if="mainList.isZF == 1">
                    <div style="margin-left:5px;font-size:13px">线上支付</div>
                  </div>
                  <div class="flexc-cen-x" v-if="mainList.isZF == 0 && mainList.vipID == 0">
                    <div style="margin-left:5px;font-size:13px">无卡预约</div>
                  </div>
                  <div class="flexc-cen-x" v-if="mainList.isZF == 0 && mainList.vipID != 0">
                    <div style="margin-left:5px;font-size:13px">会员卡支付({{mainList.vipName}})</div>
                  </div>
            </div>
            <div v-if="isyhq==1 && mainList.isZF == 1" class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px">优惠券：</div>
                  <div class="flexc-cen-x"  >
                    <div style="margin-left:5px;font-size:13px">{{mainList.yhqTitle}}</div>
                  </div>
            </div>
            <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px">扣除：</div>
                  <div class="flexc-cen-x" v-if="mainList.isZF == 1">
                    <div style="margin-left:5px;font-size:13px">{{mainList.PayAmount}}元</div>
                  </div>
                  <div class="flexc-cen-x" v-if="mainList.isZF == 0 && mainList.vipID == 0">
                    <div style="margin-left:5px;font-size:13px">无</div>
                  </div>
                  <div class="flexc-cen-x" v-if="mainList.isZF != 1 && !(mainList.isZF == 0 && mainList.vipID == 0)">
                    <div style="margin-left:5px;font-size:13px">{{mainList.vipvule}}</div>
                  </div>
            </div>
            
            <div class="flexc-cen-x" v-if="mainList.isZF == 1" style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px">付款金额：</div>
                  <div class="flexc-cen-x">
                    <div style="margin-left:5px;font-size:13px">￥{{mainList.PayAmount}}</div>
                  </div>
            </div>

      </div>
      <div class="bottomBORD" style="margin-top:30px;margin-bottom:100px"  v-if=" mainList.listPreAboutInfo && mainList.listPreAboutInfo.length > 0">
        <div style="margin-left:2%;font-size:15px;margin-bottom:30px">预约信息</div>
            <div v-for="(items,index) in mainList.listPreAboutInfo" v-if="items.state !=3" style="margin-bottom:15px;">
            <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px">{{items.Title}}:</div>
                  <div class="flexc-cen-x">
                    <div style="margin-left:5px;font-size:13px">{{items.FormsInfo}}</div>
                  </div>
            </div>
           </div>
      </div>
        <div class="demo-drawer__footer flex-r-x"  style="width:30%">
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button
          style="margin-right:20px"
            size="small"
            type="primary"
           
             @click="closeDialog"
            >确定</el-button
          >
        </div>
    </el-drawer>

    <el-dialog :title="typeName" :visible.sync="hexiaoShow" width="40%">

        <el-form label-width="120px" >
          <!-- <el-form-item :label="'使用'+name+'码:'" prop="isCode" v-if="mainList.isZF != 1 && (cardList.length != 0 &&  isCard == 1)">
            <el-radio-group v-model="isCode">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item> -->
          <el-form-item :label="name+'码'" prop="number" v-if="isCode == 1">
            <el-input size="small" placeholder="请输码" v-model="code"  auto-complete="off"></el-input>
          </el-form-item>
        <el-form-item label="会员卡:" prop="number" v-if=" isCode == 0 && isCard == 1 &&  mainList.vipID !=0  ">
          <el-select v-if="issfxk==0" v-model="mainList.vipID" placeholder="请选择" size="small" @change="tochoosevip(1)">
              <el-option
                v-for="item in cardList"
                :key="item.ID"
                :label="item.CardName + '/' + item.name"
                :value="item.ID">
              </el-option>
          </el-select>
          
         <span v-if="issfxk==1">{{mainList.vipName}} {{mainList.kyName}}</span>  
        </el-form-item>

        <el-form-item label="使用会员卡:" prop="isCode" v-if="isCode == 0 && mainList.vipID == 0 ">
          <el-radio-group v-model="isUser">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item> 
        <el-form-item label="选择会员卡:" v-if=" isUser == 1 && isCode == 0 && mainList.vipID ==0">
          <el-select v-model="vipID" placeholder="请选择" size="small" @change="tochoosevip()">
              <el-option
                v-for="item in cardList"
                :key="item.ID"
                :label="item.CardName + '/' + item.name"
                :value="item.ID">
              </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="扣金额:" prop="number" v-if="  isUser == 1 && isCode == 0 && (cardType == 4 || cardType == 5) && mainList.vipID ==0">
            <el-input size="small" placeholder="请输入金额" v-model="money" type="number"  auto-complete="off" style="width:120px"></el-input>
            元  &nbsp;<span v-if="iskczk==1">(原价：{{mainList.xhAmount}} 元)</span>
          </el-form-item>
        <el-form-item label="扣次数:" prop="number" v-if=" isUser == 1 && isCode == 0 &&(cardType == 1 || cardType == 2) && mainList.vipID ==0" >
            <el-input size="small" placeholder="请输入次数" v-model="number"  auto-complete="off" style="width:120px"> </el-input>次
        </el-form-item>
        <el-form-item label="扣金额:" prop="number" v-if="isCard == 0 && isCard == 0 && isCode == 0 && mainList.vipID == -1">
          <el-input size="small" placeholder="请输入金额" v-model="money" type="number"  auto-complete="off" style="width:120px"></el-input>
            元 &nbsp;<span v-if="iskczk==1">(原价：{{mainList.xhAmount}} 元)</span>
        </el-form-item>
        <el-form-item label="扣次数:" prop="number" v-if=" isCard == 0 && isCode == 0 && mainList.vipID == -2 " >
            <el-input size="small" placeholder="请输入次数" v-model="number"  auto-complete="off" style="width:120px"> </el-input>次
        </el-form-item> 
        <el-form-item label="扣金额:" prop="number" v-if=" isCard == 1 && (mainList.CardType ==4 ||mainList.CardType ==5 ) && isCode == 0">
          <el-input size="small" placeholder="请输入金额" v-model="money" type="number"  auto-complete="off" style="width:120px"></el-input>
            元 &nbsp;<span v-if="iskczk==1">(原价：{{mainList.xhAmount}} 元)</span>
        </el-form-item>
        <el-form-item label="扣次数:" prop="number" v-if=" isCard == 1 && isCode == 0 &&(mainList.CardType ==2 ||mainList.CardType ==1) " >
            <el-input size="small" placeholder="请输入次数" v-model="number"  auto-complete="off" style="width:120px"> </el-input>次
        </el-form-item> 
        <el-form-item label="预约人数:" prop="Note">
              <el-input-number size="small" v-model="mainList.PreAboutCount" :step="1" :min="1"></el-input-number>
        </el-form-item>
        <el-form-item :label="'选择'+WZYGName+':'" prop="number" >
            <span>{{mainList.terName}}</span>
            <el-button type="text" style="margin-left:20px" @click="handlePassword1">选择</el-button>
        </el-form-item>
        <el-form-item label="备注:" prop="Note">
              <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="Note" ></el-input>
        </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button size="small" type="primary" :loading="loading"  @click="sure()">确定</el-button>
        </div>
      </el-dialog>
    <el-dialog title="其他操作" :visible.sync="otherShow" width="40%">
      
        <el-form label-width="120px">
          <el-form-item label="原因："  prop="state">
              <el-select v-model="state" clearable placeholder="请选择" size="mini">
                    <el-option
                      v-for="item in stateList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
            </el-form-item>
          <el-form-item label="扣课时:" prop="isxk">
            <el-radio-group v-model="isxk">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        <el-form-item label="选择会员卡:" v-if="isxk == 1   && mainList.vipID ==0">
          <el-select v-model="vipID" placeholder="请选择" size="small" @change="tochoosevip()">
              <el-option
                v-for="item in cardList"
                :key="item.ID"
                :label="item.CardName"
                :value="item.ID">
              </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="金额" prop="number" v-if=" isxk == 1 && (cardType == 4 || cardType == 5) && mainList.vipID ==0">
            <el-input size="small" placeholder="请输入金额" v-model="money" type="number"  auto-complete="off" style="width:120px"></el-input>
            元
          </el-form-item>
        <el-form-item label="次数" prop="number" v-if="isxk == 1 && (cardType == 1 || cardType == 2) && mainList.vipID ==0" >
            <el-input size="small" placeholder="请输入次数" v-model="number"  auto-complete="off" style="width:120px"> </el-input>次
        </el-form-item>
        <el-form-item label="金额" prop="number" v-if="mainList.vipID == -1 && isxk == 1 && isCard == 0">
          <el-input size="small" placeholder="请输入金额" v-model="money" type="number"  auto-complete="off" style="width:120px"></el-input>
          元
        </el-form-item>
        <el-form-item label="次数" prop="number" v-if="mainList.vipID != -1 && isxk == 1 && isCard == 0" >
          <el-input size="small" placeholder="请输入次数" v-model="number"  auto-complete="off" style="width:120px"> </el-input>次
        </el-form-item>
        <el-form-item label="金额" prop="number" v-if="(mainList.CardType == 4 || mainList.CardType == 5)&& isxk == 1 && isCard == 1">
          <el-input size="small" placeholder="请输入金额" v-model="money" type="number"  auto-complete="off" style="width:120px"></el-input>
          元
        </el-form-item>
        <el-form-item label="次数" prop="number" v-if="(mainList.CardType == 1 || mainList.CardType == 2) && isxk == 1 && isCard == 1" >
          <el-input size="small" placeholder="请输入次数" v-model="number"  auto-complete="off" style="width:120px"> </el-input>次
        </el-form-item>
          <el-form-item label="备注:" prop="Note">
              <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="Note" ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="otherShow = false">取消</el-button>
          <el-button size="small" type="primary" :loading="loading"  @click="sure1()">确定</el-button>
        </div>
    </el-dialog>
    <el-dialog title="撤销" :visible.sync="cheShow" width="40%">
        <el-form label-width="120px">
          <el-form-item label="撤销原因:" prop="Note">
              <el-input type="textarea" :rows="2" placeholder="请输入原因" v-model="Note" ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cheShow = false">取消</el-button>
          <el-button size="small" type="primary" :loading="loading"  @click="sureChe()">确定</el-button>
        </div>
    </el-dialog>
    <el-dialog :title="'选择'+WZYGName" :visible.sync="personShow" width="500px" @click="personShow = false">
        <div class="dialogMain" style="width:100%;height:400px">
            <el-collapse accordion  >
                <el-collapse-item v-for="(items) in personList" :key="items.ID" >
                    <template slot="title">
                            <!-- <img src="../../assets/icon/choose.png" alt="" style="width:18px;height:18px">   -->
                            <span style="margin-left:5px">{{items.Name}}</span>
                    </template>
                    <div class="cursor" v-for="item in items.listsub" :key="item.ID" style="margin-left:20px" @click="choose(item)" >
                        <div class="flex-spc-x" style="margin-top:5px" > 
                            
                            <div style="margin-left:5px;font-size:15px">
                                {{item.Name}}
                            </div>
                            <el-button type="text">选择</el-button>
                        </div> 
                        
                    </div>
                </el-collapse-item>

            </el-collapse>

        </div>
    </el-dialog>
    <el-dialog title="选择预约人数" :visible.sync="numberShow" width="500px" @click="numberShow= false">
        <el-form label-width="120px">
          <el-form-item label="预约人数:" prop="Note">
              <el-input-number size="small" v-model="mainList.PreAboutCount" :step="1" :min="1"></el-input-number>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="numberShow = false">取消</el-button>
          <el-button size="small" type="primary" :loading="loading"  @click="sureNumber()">确定</el-button>
        </div>

    </el-dialog>
    <el-drawer :wrapperClosable= false
            class="normalDrawer"
            title="点评详情"
            direction="ltr"
            size="50%"
            :visible.sync="showRightDrawer3"
      
            >
            <div class="drawerForm">
                <el-form   label-width="100px" label-position="right">
                  <el-form-item label="点评内容:" prop="Note">
                    <el-input type="textarea" :rows="2" placeholder="请输入点评内容" v-model="info"  style="width:90%"></el-input>
                </el-form-item>
                    <el-form-item label="图片：" prop="ImgUrl">
                       <el-upload
                            :action="URL"
                            list-type="picture-card"
                            :file-list="fileList"
                            :on-preview="handlePictureCardPreview"
                            :on-remove="handleRemove1"
                            :http-request="imageChange"
                            :before-upload="beforeUp"
                            >
                            <!-- :on-success="handleAvatarSuccess" -->
                            <i class="el-icon-plus"></i>
                        </el-upload>
                     </el-form-item>
                </el-form>
            </div>
                   <div class="demo-drawer__footer flex-r-x"  style="width:50%">
          <el-button size="small" @click="showRightDrawer3 = false">取消</el-button>
          <el-button
          style="margin-right:20px"
            size="small"
            type="primary"
    
        
            @click="sureReview()"
            >保存</el-button
          >
        </div>
    </el-drawer>
  </div>
</template>

<script>
import { deptList, deptSave, deptDelete } from '../../api/userMG'
import CropperImage from "../../components/CropperImage";
import {getListManageLogin,addManageLogin,delManageLogin,editManageLogin,editManageLoginmoney,editManageLoginPwd,editManageLoginIsdisable} from "@/api/getData";
import Pagination from '../../components/Pagination'
import { baseUrl } from "../../config/env.js";
import * as imageConversion from 'image-conversion'
export default {
  data() {
    return {
      formValidate: {
        mainImage: "",
      },
      tdate:'',
       showRightDrawer3:false,
      mdate:'',
      code:'',
      row:'',
         URL: baseUrl + "upload_images.aspx",
      selectMembersName:"",
      otherShow:false,
          personList:[],
      Note:'',
      Site:'',
      selectstate:'0',
      cardList:[],
      activeName: 'first',
      value:true,
      direction: "ltr",
      projectList:[],
      passShow:false,
      isCard:localStorage.getItem("isCard"),
      input:'',
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      chongShow:false,
      SelectStoresID:localStorage.getItem("StoresID"),
      IsCD:localStorage.getItem("IsCD"),
      iskczk:localStorage.getItem("iskczk"),
      issfxk:localStorage.getItem("issfxk"),
      isyhq:localStorage.getItem('isyhq'),
      title: '添加',
      tableData:[],
      isUser:'',
      cardType:'',
      Pwd:'',
      objID:'',
      site:'',
      mainList:[],
      DianList:[],
      cheShow:false,
         WZYGName:'',
    WZHYName:'',
    WZXMName:'',
    WZPBName:'',
      hexiaoShow:false,
      LoginID:-1,
      stateList:[
        {
          value:3,
          label:'未到'

        },
      
         {
          value:5,
          label:'请假'

        },
      ],
  
    //   SelectStoresID:1,
      editForm: {
        LoginName:"",
        Phone:"",
        Name:"",
        pwd:"",
        money:"",
        ShopName:"",
        token: localStorage.getItem('token')
      },
      money:1.00,
      // rules表单验证
personShow:false,     
      rules: {
        LoginName: [{ required: true, message: '请输入登录账号', trigger: 'blur' }],
          Phone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
          Name: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
          pwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
          money: [{ required: true, message: '请输入余额', trigger: 'blur' }],
          ShopName: [{ required: true, message: '请输入商户名称', trigger: 'blur' }],
      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      isCode:0,
      number:1,
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      info:'',
      isxk:0,
      state:'',
      Limits:[],
      fileList:[],
      q1:false,
      q2:false,
      q3:false,
      q4:false,
      q5:false,
      q6:false,
      typeName:'',
      GoodsList:[],
      WZCDName:'',
      numberShow:false,
    }
  },
  // 注册组件
  components: {
    Pagination,
     CropperImage,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.WZYGName = localStorage.getItem('WZYGName')
    this.WZHYName = localStorage.getItem('WZHYName')
    this.WZXMName = localStorage.getItem('WZXMName')
    this.WZPBName = localStorage.getItem('WZPBName')
    this.WZCDName = localStorage.getItem('WZCDName')
    this.getList1()
      if(localStorage.getItem('StoresType')== 1){
          this.name = '签到'
            this.nmae1 = localStorage.getItem('zzjy') 
          this.typeName = '签到'
        
      }  else {
          this.typeName = '核销'
          this.name = '核销'
          this.nmae1 = localStorage.getItem('zzjy') 
      }     
      if(localStorage.getItem('isAdmin') == 1){
          this.q1 = true
          this.q2 = true
          this.q3 = true
          this.q4 = true
          this.q5 = true
          this.q6 = true
      }
  this.Limits = localStorage.getItem('Limits')
      this.Limits = this.Limits.split(',')
      this.Limits.forEach(items => {
          if(items == 22){
            this.q1 = true
          }
          if(items == 23){
            this.q2 = true
          }
          if(items == 24){
            this.q3 = true
          }
          if(items == 25){
            this.q4 = true
          }
          if(items == 26){
            this.q5 = true
          }
          if(items == 43){
            this.q6 = true
          }
          
   })
          var date = new Date();
          var year = date.getFullYear();
          var month = date.getMonth() + 1;
          var day = date.getDate();


          if (month < 10) {
          month = '0' + month;
          }
          if (day < 10) {
          day = '0' + day;
          }
          // var nowDate = 
        // this.data.[0] = 
      this.tdate = year + '-' + month + '-' + day;
      var days = 6
      var last = new Date(date.getTime() + (days * 24 * 60 * 60 * 1000))
        year = last.getFullYear();
        month = last.getMonth() + 1;
        day = last.getDate();   

      this.mdate = year + '-' + month + '-' + day;
    
      this.getDianList()
      this.getSiteList()
      this.getProjectList()
     this.getList()
      // this.ge1tList()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
              beforeUp(file){
                const isLt2M = file.size / 1024 / 1024 < 10;
                
                    if (!isLt2M) {
                        this.$message.error('上传头像图片大小不能超过 10MB!');
                        return(false)
                } 


                return new Promise((resolve, reject) => {
                
                        console.log('压缩前', file) // 压缩到400KB,大于400KB的图片都会进行压缩，小于则不会
                        imageConversion.compressAccurately(file, 1000).then(res => { // console.log(res)
                        res = new File([res], file.name, { type: res.type, lastModified: Date.now() })
                        console.log('压缩后', res)
                        resolve(res)
                        })
                    

                      
                })
            },
        handleRemove1(file, fileList) {
            if (file && file.status==="success") {
                  console.log(fileList) 
                  this.fileList  = fileList
            }
             
    },

    handlePictureCardPreview(file) {
                 this.dialogImageUrl = file.url;
                   this.dialogVisible1 = true;
    }, 
    imageChange(param,type){
        let formData = new FormData();
        var URL = baseUrl + "upload_images.aspx";
        formData.append('file',param.file)
        console.log(param.file)
        formData.append("token",localStorage.getItem("token"));
        this.$axios.post(URL,formData).then((res) =>{
            if(res.data.orsuccess == 1){
                console.log(this.fileList)
                this.fileList.push({url:res.data.url,uid:this.fileList.length + 1,status:"success"})
         }
       })
      },
        sureReview(){
      var list = []
       this.fileList.forEach(items => {
        list.push(items.url)
      }); 
       console.log(list)
      if(this.info == '' && this.fileList.length == 0){
              this.$message({ type: "error", message: "请输入点评" ,duration:1000});
                return;
        } else {
          if(this.addshow == true){
                var data = { 
                SelectStoresID:this.SelectStoresID,        
                StoresID:localStorage.getItem("StoresID"),
                token: localStorage.getItem("token"),
                StudentID:this.mainList.MembersID,
                RowClassID:this.mainList.RowClassID,
                TeacherID:localStorage.getItem("LoginID"),
                ReviewInfo:this.info,
                listimgs:list.join(",")
              
                  }
              var that = this
              this.ajax('addReview.aspx',JSON.stringify(data),"POST",function(res){
                           
                            if (res.orsuccess == "1") {
                               that.showRightDrawer3 = false
                                that.$message({
                              type: "success",
                              message: "点评成功",duration:2000,
                            });
                            }
              })
          } else {
            
       var data = { 
                SelectStoresID:this.SelectStoresID,        
                StoresID:localStorage.getItem("StoresID"),
                token: localStorage.getItem("token"),
                StudentID:this.pinList.info.StudentID,
                RowClassID:this.pinList.info.RowClassID,
                TeacherID:localStorage.getItem("LoginID"),
                ReviewInfo:this.info,
                ReviewID:this.pinList.info.ID,
                listimgs:list.join(",")
        }
              var that = this
              this.ajax('editReview.aspx',JSON.stringify(data),"POST",function(res){
                  if (res.orsuccess == "1") {
                                  that.showRightDrawer3 = false
                                  that.$message({
                                type: "success",
                                message: "点评成功",duration:2000,
                              });
                  }
              })
         


          }
        
        }
    },
   dian(row){
     console.log(row)
      this.mainList = row
      this.getPinList()
       
    },
    getPinList(){
       this.addshow = false
      var data = { 
                SelectStoresID:this.SelectStoresID,        
                StoresID:localStorage.getItem("StoresID"),
                token: localStorage.getItem("token"),
                StudentID:this.mainList.MembersID,
                RowClassID:this.mainList.RowClassID
              
        }
              var that = this
              this.ajax('getReviewinfo.aspx',JSON.stringify(data),"POST",function(res){
                  that.showRightDrawer3 = true
                   that.fileList =[];
                if (res.orsuccess == "1") {
                  if(!res.data.info.StudentID){
            
                    that.addshow = true
                    that.info = ''      
                
                 } else {
                   that.info = res.data.info.ReviewInfo
                 }
                  that.GoodsList = res.data.listimge
                  
                      for (let i = 0; i < that.GoodsList.length; i++) {
                        const element = that.GoodsList[i];
                        that.fileList.push({url:element.ImgUrl,uid: element.ID,status:"success"})
                    }
                  that.pinList = res.data
                  that.dianShow = true
                }
          })
  },
    sureNumber(){
       var that = this
   
            var data = { 
              SelectStoresID:this.SelectStoresID,
              StoresID:localStorage.getItem("StoresID"),
              token: localStorage.getItem("token"),
              PreAboutID:this.mainList.ID,
              PreAboutCount:this.mainList.PreAboutCount
            }
         
            this.ajax('editPreAboutCount.aspx',JSON.stringify(data),"POST",function(res){
              if (res.orsuccess == "1") {

                  that.$message({
                    type: "success",
                    message: "修改成功",duration:2000,
                  });
                  that.numberShow = false
                  that.getList()
                 
                }
            })
        // PreAboutCount
    },
    toNumber(row){
      this.mainList =row
      this.numberShow = true
    },
        handlePassword1(){

        this.personShow = true

    },
        choose(items){
          this.mainList.terName = items.Name
          this.mainList.StaffID = items.ID
          this.personShow = false

      },
        getList1(){

    //  this.tableLoading = true
       var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:1,
          psize:100,
          StaffTypeID:''
      }
     
      
      var that = this
      this.ajax('getlistStaffgl.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
          
                that.personList = res.data
          } 

      })
  
  
    },
    chexiao(row){
        this.mainList = row
        this.cheShow = true
        this.Note = ''
    },
    sureChe(){
      if(this.Note == ''){
         this.$message({ type: "error", message: "请选择原因" ,duration:1000});
                  return;
      }
      var that = this
          if(this.mainList.isZF == 1){
            var data = { 
              SelectStoresID:this.SelectStoresID,
              StoresID:localStorage.getItem("StoresID"),
              token: localStorage.getItem("token"),
              PreAboutID:this.mainList.ID,
              loginName:localStorage.getItem("Name"),
              loginID:localStorage.getItem("LoginID"),
              Note:this.Note,
            }
         
            this.ajax('RevocationPreAboutPay.aspx',JSON.stringify(data),"POST",function(res){

              if (res.orsuccess == "1") {

                  that.$message({
                    type: "success",
                    message: "撤销成功",duration:2000,
                  });
                  that.cheShow = false
                  that.getList()
                 
                }
            })
          
          }  else {
           if(this.isCard == 1){
              var data = { 
                SelectStoresID:this.SelectStoresID,
                StoresID:localStorage.getItem("StoresID"),
                token: localStorage.getItem("token"),
                PreAboutID:this.mainList.ID,
                loginName:localStorage.getItem("Name"),
                loginID:localStorage.getItem("LoginID"),
                Note:this.Note,
              }
              this.ajax('RevocationPreAbout.aspx',JSON.stringify(data),"POST",function(res){

                if (res.orsuccess == "1") {

                    that.$message({
                      type: "success",
                      message: "撤销成功",duration:2000,
                    });
                    that.cheShow = false
                    that.getList()
                    //  that.provinceList = res.data
                  }
              })
           } else {
               var data = { 
              SelectStoresID:this.SelectStoresID,
              StoresID:localStorage.getItem("StoresID"),
              token: localStorage.getItem("token"),
              PreAboutID:this.mainList.ID,
              loginName:localStorage.getItem("Name"),
              loginID:localStorage.getItem("LoginID"),
              Note:this.Note,
            }
         
            this.ajax('RevocationPreAboutNoCrad.aspx',JSON.stringify(data),"POST",function(res){

              if (res.orsuccess == "1") {

                  that.$message({
                    type: "success",
                    message: "撤销成功",duration:2000,
                  });
                  that.cheShow = false
                  that.getList()
                  //  that.provinceList = res.data
                }
            })
          
           }
      }
    },
    tochoosevip(items){
      if(items == 1){
           this.cardList.forEach(items=>{
                if(this.mainList.vipID == items.ID){
                        this.mainList.CardType = items.CardType
        
                }
              })
      } else {
      this.cardList.forEach(items=>{
                if(this.vipID == items.ID){
                        this.cardType = items.CardType
                      
                }
              })
            }
       
    },
    changedian(){
      this.getSiteList()
      this.getProjectList()
      this.getList()
    },

        getListMembersvip1(){
         
        var data = { 

          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          MembersID: this.mainList.MembersID

      }

      var that = this
      this.ajax('getListMembersvip.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
            
                that.cardList = res.data

                that.cardList.forEach(items => {
                  console.log('1111')
                  if(items.CardType == 1|| items.CardType == 2){
                    items.name = '可用' + items.CardNumber +'次'
                  }
                  if(items.CardType == 4|| items.CardType == 5){
                    items.name = '可用' + items.Amount +'元'
                  }
                 if(items.CardType == 3){
                   items.name = ' '
                 }
                });
                // console.log(that.cardList)
                if(that.cardList.length == 0 && that.mainList.isZF == 1){
                      that.isCode = 1
                     
                }
                if(that.otherShow == false){
                    that.hexiaoShow = true
                }
             
          } 

      })
     this.vipID =''
    },
    sure1(){
      console.log(this.state)
      if(this.state == ''){
        this.$message({ type: "error", message: "请选择原因" ,duration:1000});
                          return;
      }

       if(this.money < 0  && ( this.mainList.CardType == 4 ||this.mainList.CardType == 5) && this.isxk == 1 && this.isCard == 1){
        this.$message({ type: "error", message: "请输入消耗金额" ,duration:1000});
                          return;
      }
       if(this.number < 0  && (this.mainList.CardType ==2 ||this.mainList.CardType ==1) && this.issk == 1 && this.isCard == 1){
         this.$message({ type: "error", message: "请输入消耗次数" ,duration:1000});
                          return;
      }
      if(this.money < 0  && this.mainList.vipID == -1 && this.isxk == 1 &&  this.isCard == 0){
        this.$message({ type: "error", message: "请输入消耗金额" ,duration:1000});
                          return;
      }
       if(this.number < 0  && this.mainList.vipID != -1 && this.issk == 1 &&  this.isCard == 0){
        this.$message({ type: "error", message: "请输入消耗次数" ,duration:1000});
                          return;
      }
    
        if(this.mainList.vipID == 0 && this.isxk == 1){
            var vipID = this.vipID
      } else  {
        var vipID = this.mainList.vipID
      }
        var data = { 
                SelectStoresID:this.SelectStoresID,        
                StoresID:localStorage.getItem("StoresID"),
                token: localStorage.getItem("token"),
                PreAboutID:this.mainList.ID,
                loginID:localStorage.getItem("LoginID"),
                Note:this.Note,
                sourceName:localStorage.getItem("Name"),
                isxk:this.isxk,
                state:this.state,
                ConsumptionOfClass:this.number,
                singlePrice:this.money,
                vipID:vipID,
                StaffID:this.mainList.StaffID,
                PreAboutCount:this.mainList.PreAboutCount
              }
              var that = this
              this.ajax('editPreAboutStateQT.aspx',JSON.stringify(data),"POST",function(res){

                if (res.orsuccess == "1") {
                    that.$message({
                      type: "success",
                      message: "操作成功",duration:2000,
                    });
                    that.otherShow = false
                    // that.getType()
                    that.getList()
                    //  that.provinceList = res.data
                  }

              })
    },
    sure(){

      if(this.money < 0   && (this.mainList.CardType ==4 ||this.mainList.CardType ==5) && this.isCard == 1 && this.isCode == 0){
        this.$message({ type: "error", message: "请输入消耗金额" ,duration:1000});
                          return;
      }
       if(this.number <0  && (this.mainList.CardType ==2 ||this.mainList.CardType ==1) && this.isCard == 1 && this.isCode == 0){
        this.$message({ type: "error", message: "请输入消耗次数" ,duration:1000});
                          return;
      }
            if(this.money < 0  && this.mainList.vipID == -1 && this.isxk == 1 &&  this.isCard == 0){
        this.$message({ type: "error", message: "请输入消耗金额" ,duration:1000});
                          return;
      }
       if(this.number <0  && this.mainList.vipID != -1 && this.issk == 1 &&  this.isCard == 0){
        this.$message({ type: "error", message: "请输入消耗次数" ,duration:1000});
                          return;
      }
      if(this.code == '' && this.isCode == 1){
        this.$message({ type: "error", message: "请输入码" ,duration:1000});
                          return;
      }




    if(this.mainList.vipID == 0 && this.isxk == 1){
          var vipID = this.vipID
      } else  {
        var vipID = this.mainList.vipID
      }

        this.$confirm('是否确认'+ this.name, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                          var data = { 
          SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          PreAboutID:this.mainList.ID,
          loginID:localStorage.getItem("LoginID"),
          Note:this.Note,
          sourceName:localStorage.getItem("Name"),
          isCode:this.isCode,
          VerificationCode:this.code,
          ConsumptionOfClass:this.number,
          singlePrice:this.money,
          vipID:vipID,
          StaffID:this.mainList.StaffID,
          PreAboutCount:this.mainList.PreAboutCount
        
        }
        var that = this
        this.ajax('editPreAboutState.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "操作成功",duration:2000,
              });
              that.hexiaoShow = false
              // that.getType()
              that.getList()
              //  that.provinceList = res.data
            }

        })
    
                    }).catch(() => {
                            
                    });
                
    
      
    },
    toOther(row){
      // this.otherShow = true
      // this.mainList = row
      // this.state = ''
      // this.Note = '',
      // this.isxk = 0
      // this.money = 0 
      // this.number = 0
      this.otherShow = true
      this.mainList = row
      this.state = ''
      this.Note = '',
      this.isxk = 0
   
      this.money = this.mainList.xhAmountsj
      this.number = this.mainList.xhnumber
      this.isUser = 0
      if(this.isCard == 1){

          this.getListMembersvip1()
      } 
    },
    hexiao(row){
      this.mainList = row
      if(this.mainList.vipID == 0){
          this.isUser = 0
          this.vipID = ''
          this.CardType = ''
      }
      
      if(this.mainList.isZF == 1){
          this.isCode = 1
      } else {
          this.isCode = 0
      }
    

      this.code = ''

      this.money = this.mainList.xhAmountsj
      this.number = this.mainList.xhnumber
       if(this.isCard == 1){

          this.getListMembersvip1()
        }  else {
             this.hexiaoShow = true
        }
       
    },
     hexiao1(){
      this.code = ''
      this.hexiaoShow = true
      this.iscode = 1
      this.money = this.mainList.xhAmountsj 
      this.number = this.mainList.xhnumber
    },

     getProjectList(){
        var data = { 
            SelectStoresID:this.SelectStoresID,        
            token: localStorage.getItem("token"),
            StoresID:localStorage.getItem("StoresID"),
            pages:1,
            psize:200,
            ProjectTypeID:0
          // StaffTypeID:this.active
      }

      
        var that = this
      this.ajax('getListProject.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {

                that.projectList = res.data

          } 

      })
      },
        getSiteList(){
       var data = { 
        SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:1,
          psize:200,

      }
  
        var that = this
      this.ajax('getListSite.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
            
                that.siteList = res.data
      
          } 

      })
    },
     getDianList(){
       var data = { 
         SelectStoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID")
      }
        var that = this
       this.ajax('getListStores.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.DianList =res.data
               
            }

      })
    },
    getList(){

      if(this.mdate < this.tdate){
        this.$message({ type: "error", message: "结束时间不得小于开始时间" ,duration:1000});
            return;
      }

      var data = { 
         SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          selectMembersName:this.selectMembersName,
          SKtime1:this.tdate,
          SKtime2:this.mdate,
          objID:this.objID,
          Site:this.Site,
          LoginID:this.LoginID,
          state:this.selectstate,
          pages:this.formInline.page,
          psize:this.formInline.limit,
      }
        var that = this
        const loading = this.$loading({
            lock: true,
            text: '加载中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
       this.ajax('getListPreAbout.aspx',JSON.stringify(data),"POST",function(res){
           if (res.orsuccess == "1") {
              res.data.forEach(items => {
                items.SKtime = items.SKtime.replace(/\//g, '-')
              });
              that.tableData = res.data
              that.pageparm.total = res.allcount

              
            }
            loading.close();

      })
    },

    handlePassword(row){
      // this.editForm.ManageLoginID = row.ID
      this.Pwd = ''
      this.passShow = true

    },
    handleChong(row){
      this.editForm.ManageLoginID = row.ID
      this.editForm.money = row.money
      this.chongShow = true
      this.money = ''
    },
    // 获取公司列表

    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getList()
    },
    // 搜索事件
    
    search() {
      this.getList()
      
    },
    noSearch(){
        this.objID =''
        this.Site = ''
        this.LoginID = -1
        this.selectMembersName = ''
        var date = new Date();
          var year = date.getFullYear();
          var month = date.getMonth() + 1;
          var day = date.getDate();
          if (month < 10) {
          month = '0' + month;
          }
          if (day < 10) {
          day = '0' + day;
          }
 
        // this.data.[0] = 
      this.date[0] = year + '-' + month + '-' + day;
      this.date[1] = year + '-' + month + '-' + day;
      this.formInline.page = 1
      this.formInline.limit = 10
      this.pageparm={
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
      this.getList()
    },
    //显示编辑界面
    handleEdit: function(row) {
      this.row = row
        var data = { 

          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          PreAboutID:row.ID
        
      }
        var that = this
       this.ajax('getPreAboutInfo.aspx',JSON.stringify(data),"POST",function(res){
           if (res.orsuccess == "1") {
              that.mainList  = res.data
              that.mainList.addTime  = that.mainList.addTime.replace(/\//g, '-')
              that.editFormVisible = true
            }
      })
  
      

    },
    // 编辑、增加页面保存方法
    submitForm(editData) {

      this.$refs[editData].validate(valid => {
        if (valid) {
            if(this.title == '添加'){
                this.add()
            }else {
                this.edit()
            }
        } else {
          return false
        }
      })
    },



  handlejie(row) {
      if(row.Isdisable == 0){
        this.$confirm('确定要禁用吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(() => {
                  this.jie(row)
              })
              .catch(() => {
                
              })
      } else {
        this.$confirm('确定要解禁吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
                .then(() => {
                    this.jie1(row)
                })
                .catch(() => {
                  
                })
          }
      
    },

    todel(items){
      if(items.isZF == 1){
        this.$confirm("确定要取消预约吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
            var data = { 
              SelectStoresID:this.SelectStoresID,
              StoresID:localStorage.getItem("StoresID"),
              token: localStorage.getItem("token"),
              PreAboutID:items.ID,
              loginID:localStorage.getItem("LoginID"),
              Note:'',
            }
            var that = this
            this.ajax('editPreAboutStateTK.aspx',JSON.stringify(data),"POST",function(res){

              if (res.orsuccess == "1") {
                  that.$message({
                    type: "success",
                    message: "取消成功",duration:2000,
                  });
            
                  that.getList()
              
                  //  that.provinceList = res.data
                }

            })
            })
            .catch(() => {

            });
      

      } else {
          if(items.RowClassTypeqt == 1){ 
              this.$confirm("确定要取消预约吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
            var data = { 
              SelectStoresID:this.SelectStoresID,
              StoresID:localStorage.getItem("StoresID"),
              token: localStorage.getItem("token"),
              PreAboutID:items.ID,
              loginID:localStorage.getItem("LoginID"),
              Note:'',
            }
            var that = this
            this.ajax('editPreAboutStateQXQT.aspx',JSON.stringify(data),"POST",function(res){

              if (res.orsuccess == "1") {
                  that.$message({
                    type: "success",
                    message: "取消成功",duration:2000,
                  });
            
                  that.getList()
            
                }

            })
            })
            .catch(() => {

            });
      

              } else{
                  this.$confirm("确定要取消预约吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
            var data = {
                SelectStoresID:this.SelectStoresID,
                StoresID:localStorage.getItem("StoresID"),
                token: localStorage.getItem("token"),
                PreAboutID:items.ID,
                loginID:localStorage.getItem("LoginID"),
                Note:'',
            }
            var that = this
            this.ajax('editPreAboutStateQX.aspx',JSON.stringify(data),"POST",function(res){

              if (res.orsuccess == "1") {
                  that.$message({
                    type: "success",
                    message: "取消成功",duration:2000,
                  });
            
                  that.getList()
            
                  //  that.provinceList = res.data
                }

            })
            })
            .catch(() => {
            
            });
      

            }
      }

    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
            this.delete(row)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.hexiaoShow = false,
      this.passShow = false,
      this.chongShow = false,
      this.editFormVisible = false
    }
  }
}
</script>
<style>
.csss .el-form-item {
    margin-bottom: 5px;
}

</style>
<style scoped>
.bottomBORD{
  padding-bottom: 30px;
  width:100%;
  border-bottom: 1px solid #e9e9e9;
}

.main{
  position: absolute;
}
.content{
    font-size: 12px;
  color: #999;
  line-height: 20px;
}
.titleMain{
    font-size: 14px;
    color: #191919;
    line-height: 22px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.offline___NHq4e {
    position: absolute;
    top: -1px;
    right: -1px;
    padding: 0.5px 4px 0.5px 4px;
    /* width: 64px; */
    /* height: 22px; */
    background: rgba(255, 101, 247, 0.04);
    border-radius: 0 8px 0 8px;
    border: 1px solid rgba(187, 14, 255, 0.2);
    font-size: 12px;
    text-align: center;
    line-height: 20px;
    color: #b336fc;
}
.box{
  position: relative;
    width: calc((100% - 80px)/4);
    padding: 20px;
    box-sizing: border-box;
    display: inline-block;
    margin-right: 16px;
    margin-bottom: 16px;
    border-radius: 8px;
    border: 1px solid #ececec;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
    height: 130px;
}
@media screen and ( max-width: 1400px ) {
  .box{
    cursor: pointer;
    width: calc((100% - 60px)/3);
  }
}
.box:hover{
  box-shadow: 0 4px 16px 0 rgb(0 0 0 / 16%);
}
.shadow:hover {
    border:1px solid #808080;border-radius:2px
}
.shadow {
    border:1px solid #ffffff;border-radius:2px
}

.xiang{
    padding: 1px 4px  1px 4px;
    background-color: #f7f7f7;
    border:1px solid #bbbbbb;
    border-radius: 3px;
    font-size: 10px;
    color:#bbbbbb;
}
  
/* .el-switch__core::after{
 height: 12px !important;
 width :12px !important;
} */
   
.title{
    margin-top: 10px;
    height: 30px;
    font-size: 13px;
    font-weight: bolder;
    border-radius: 3px;
    border-left: 5px solid #334157;

}
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/billboard/billboard.vue